import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
  QueryList,
  signal,
  viewChildren,
  ViewChildren,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subject, firstValueFrom } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { BackendLocaleDatePipe } from 'src/app/pipes/get-locale-date.pipe';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { BasicStoreService } from 'src/app/services/BasicStore/basic-store.service';
import { OverlayService } from 'src/app/services/Overlay/overlay.service';
import { ColumnHideManService } from 'src/app/services/Shared/colhidemanager.service';
import { DotDotDotPipe } from '../../pipes/dot-dot-dot.pipe';
import { HideIDColumnsPipe } from '../../pipes/hide-idcolumns.pipe';
import { MrUnitTextPipe } from '../../pipes/mrUnitText.pipe';
import { TablePrettyPrintPipe } from '../../pipes/tablePrettyPrint.pipe';
import { ClarityModule, ClrDatagridColumn } from '@clr/angular';
import { CommonModule } from '@angular/common';
import { Table } from 'src/app/models/ui/table';
import { SXBEG } from 'src/app/services/_offline/dexieDB';
import { DBStatus } from 'src/app/types/api';
import { ImageSlideShowComponent } from '../_components/_shared/media-slide-show/image-slide-show.component';
import { ReplikatBegehungenSetupComponent } from '../_components/_modals/replikat-begehungen-setup/replikat-begehungen-setup.component';
import { ReplikatProgressComponent } from '../_components/_modals/replikat-progress/replikat-progress.component';
import { SetupConfig } from 'src/app/services/_offline/rep-setup.service';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { getTokenRight } from 'src/app/misc/functions';
import {
  FILTER_TABLE_STORE,
  FILTER_TABLE_STORE_II,
  provideFilterStore,
} from 'src/app/shared/stores/filter-table.store';
import { ColumnFilterComponent } from '../_components/filter/column-filter/column-filter.component';
import { ConfirmService } from 'src/app/services/confirm.service';
import { IconDgCellComponent } from '../_components/_shared/datagrid-cell/icon-dg-cell.component';
import { BegehungApiService } from 'src/app/services/APIService/begehung.api.service';
import { GetByCallbackPipe } from 'src/app/pipes/get-by-callback.pipe';
import { BeschreibungService } from 'src/app/services/beschreibung.service';

@Component({
  selector: 'app-begehung',
  templateUrl: './begehung.component.html',
  styleUrls: ['./begehung.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    ImageSlideShowComponent,
    ReplikatBegehungenSetupComponent,
    ReplikatProgressComponent,
    ColumnFilterComponent,
    IconDgCellComponent,
    TablePrettyPrintPipe,
    MrUnitTextPipe,
    HideIDColumnsPipe,
    MrTranslatePipe,
    GetByCallbackPipe,
  ],
  providers: [provideFilterStore({ secondStore: true })],
})
export class BegehungComponent implements OnInit, OnDestroy, AfterViewInit {
  private readonly apiService = inject(BegehungApiService);
  protected readonly authService = inject(AuthService);
  private readonly mrTranslate = inject(MrTranslatePipe);
  private readonly toastr = inject(ToastrService);
  private readonly basicStore = inject(BasicStoreService);
  private readonly overlayService = inject(OverlayService);
  private readonly colHideService = inject(ColumnHideManService);
  private readonly confirmService = inject(ConfirmService);
  protected readonly localeDate = inject(BackendLocaleDatePipe);
  protected readonly filterStore = inject(FILTER_TABLE_STORE);
  protected readonly filterStore_II = inject(FILTER_TABLE_STORE_II);
  protected readonly changeDetectorRef: ChangeDetectorRef;

  private readonly columnFilters = viewChildren<ColumnFilterComponent>('begehungen');
  private readonly columnFilters_II = viewChildren<ColumnFilterComponent>('objekte');

  protected isconfiged: boolean = false;

  protected obegeid: number = 0;
  protected obegpid: number = 0;
  private title: string = '';
  protected objekte: Table;
  protected zuordnungTable: SXBEG[];

  protected readonly begehungTable = signal<Table<BegehungPlanNode>>({ columns: [], rows: [] });
  protected readonly selectedZuordnungTable = signal<Table>({ columns: [], rows: [] });

  protected begehungHistoryTable: Table<BegehungHistorieNode>;
  protected selectedBegehung: BegehungPlanNode;
  protected selectedHistoryBegehung: BegehungHistorieNode;
  protected iconColumns: string[] = ['typ', 'sperrstatus', 'lfstatus', 'rep', 'icon'];
  protected canContinueBegehung: boolean = false;
  protected sxbepTable: Table;
  protected colFname: string = 'Begehung';
  protected selectedObjekt: any;
  protected selectedObjektBilder: any[];
  protected isRep = this.apiService.isRep;
  protected readonly allowRepErstellen: boolean;
  protected readonly allowRepZurückspielen: boolean;

  protected readonly isReplikatProgressOpen = signal(false);
  protected readonly isUserReplikatModalOpen = signal(false);
  protected readonly setupConfig = signal<SetupConfig>(undefined);
  protected readonly showBeschreibungText = signal('');

  private readonly dataRefresh = new Subject<void>();
  private readonly refreshSubscription = this.dataRefresh.subscribe(() => this.loadFormItem());
  @ViewChildren(ClrDatagridColumn) columns: QueryList<ClrDatagridColumn>;
  formatDBName: string = localStorage.getItem('FormatCurDB').replace('_', ' ');
  hides = ['_tag', 'obegeid', 'obegpid', 'OBEGEID', 'OBEGPID', 'gruppen', 'Gruppen'];
  loaded: boolean = false;
  private beschreibungService = inject(BeschreibungService);

  constructor() {
    const token = this.authService.getToken();
    this.allowRepErstellen = getTokenRight(token.rights.program, 'AllowPREPCR');
    this.allowRepZurückspielen = getTokenRight(token.rights.program, 'AllowPREPSY');

    this.filterStore.registerFilters(this.columnFilters);
    this.filterStore.registerTable(this.begehungTable);
    this.filterStore_II.registerFilters(this.columnFilters_II);
    this.filterStore_II.registerTable(this.selectedZuordnungTable);
  }

  ngOnInit() {
    this.loadFormItem();
    this.hides = this.colHideService.initColHide(this.hides, this.colFname);
  }
  ngAfterViewInit(): void {
    this.loaded = true;
  }

  ngOnDestroy() {
    this.refreshSubscription.unsubscribe();
    this.colHideService.setColHide(this.columns, this.colFname);
  }

  columnHiddenChange() {
    this.colHideService.columnHiddenChange(this.columns).then((x: string[]) => (this.hides = x));
  }

  removeColFilter() {
    this.hides = this.colHideService.removeColHide(this.colFname);
  }
  async loadFormItem() {
    this.isconfiged = false;
    this.obegeid = 0;
    const { success, error, obege, sxbeg, obegp_history } = await firstValueFrom(this.apiService.getBegehungsplan());

    if (success) {
      if (obege.rows.length) {
        this.isconfiged = true;
        this.begehungTable.set(obege);
        this.zuordnungTable = sxbeg;
        this.begehungHistoryTable = obegp_history;
        this.setObjektTabelle();
      }
    } else this.toastr.error(error, this.mrTranslate.transform('Etwas ist schief gelaufen'));
  }

  async setObjektTabelle() {
    const anlagen = await firstValueFrom(
      this.basicStore.getComponentStoreAsync('anlagen').pipe(
        map<string, Table>(x => x && JSON.parse(x)?.anlagen),
        first(anlagen => !!anlagen?.rows)
      )
    );
    this.objekte = anlagen;
  }

  openBegehungsEinstellungen() {
    this.overlayService.setOverlay({
      overlay: 'begehungsVerwaltung',
      dataRefresh: this.dataRefresh,
    });
  }

  addBegehung() {
    this.obegpid = 0;

    this.overlayService.setOverlay({
      overlay: 'begehungsDialog',
      obegeid: this.obegeid,
      obegpid: this.obegpid,
      titel: this.title,
      objekttabelle: this.selectedZuordnungTable(),
      beschreibung: this.showBeschreibungText(),
      dataRefresh: this.dataRefresh,
    });
  }

  continueBegehung() {
    this.overlayService.setOverlay({
      overlay: 'begehungsDialog',
      obegeid: this.obegeid,
      obegpid: this.obegpid,
      titel: this.title,
      objekttabelle: this.selectedZuordnungTable(),
      dataRefresh: this.dataRefresh,
    });
  }

  selectionObjektChanged(value: any) {
    this.selectedObjektBilder = [];
    if (value && this.sxbepTable?.rows) {
      const bilder = this.sxbepTable.rows.find(row => row.OSTAMMID == value.OSTAMMID)?.bilder;
      if (bilder) {
        this.selectedObjektBilder = typeof bilder == 'string' ? JSON.parse(bilder) : bilder;
      }
    }
  }

  selectionHistoryChanged(value: any) {
    this.canContinueBegehung = false;
    if (value != undefined) {
      this.obegpid = value.ID;
      this.getsxbepTable();
      this.canContinueBegehung = value.Abgeschlossen == false && value.ID != 0;
    }
  }

  protected readonly getGridValue = (row: any, type: string) => {
    if (!this.sxbepTable) return;
    if (type == 'closed') {
      let index = this.sxbepTable.rows.findIndex(element => element['OSTAMMID'] == row.OSTAMMID);
      return index != -1;
    }
    if (type == 'date') {
      let index = this.sxbepTable.rows.findIndex(element => element['OSTAMMID'] == row.OSTAMMID);
      if (index != -1) {
        let r = this.sxbepTable.rows[index];
        return r.CompletedDate;
      }
    }
  };

  getsxbepTable() {
    let obegp = {
      status: 'getsxbep',
      obegeid: this.obegeid,
      obegpid: this.obegpid,
    };

    this.apiService
      .setBegehung(obegp)
      .pipe(first())
      .subscribe((res: any) => {
        if (res?.success) {
          this.sxbepTable = res.result.sxbep;
          this.selectionObjektChanged(this.selectedObjekt);
        } else this.toastr.error(res?.error, this.mrTranslate.transform('Etwas ist schief gelaufen'));
      });
  }

  async selectionGridChanged(value: BegehungPlanNode) {
    this.obegpid = 0;
    this.selectedObjekt = null;
    if (value != undefined) {
      this.obegeid = value.OBEGEID;
      this.title = value.Begehungsart;
      this.begehungHistoryTable.rows = [];

      const { success, obegp_history, error } = await firstValueFrom(
        this.apiService.getBegehungsplanHistory(value.OBEGEID)
      );
      if (success) {
        this.begehungHistoryTable.rows = obegp_history.rows;
      } else this.toastr.error(error, this.mrTranslate.transform('Etwas ist schief gelaufen'));

      let rows = this.zuordnungTable.filter(cells => cells.OBEGEID == value.OBEGEID);

      this.showBeschreibungText.set(value.Beschreibung);

      let r = [];

      for (let zurow of rows) {
        let index = this.objekte.rows.findIndex(element => element['OSTAMMID'] == zurow['OSTAMMID']);
        if (index > -1) {
          r.push(this.objekte.rows[index]);
        }
      }

      this.selectedZuordnungTable.set({
        columns: [...this.objekte.columns],
        rows: [...r],
      });
    }
  }

  protected async stopReplicate() {
    if (!this.allowRepZurückspielen) {
      this.toastr.warning(this.mrTranslate.transform('Für diese Aktion fehlen die Rechte'));
      return;
    }
    const text = this.mrTranslate.transform('Sind Sie sicher, dass Sie das Replikat zurückspielen wollen?');
    const ok = await this.confirmService.info(text);
    if (ok) this.isReplikatProgressOpen.set(true);
  }

  showInfo(event: MouseEvent, row: any): void {
    event.stopPropagation();
    this.beschreibungService.show({ title: this.mrTranslate.transform('Beschreibung'), message: row['Beschreibung'] });
  }
}

export interface BegehungPlanNode extends DBStatus {
  OBEGEID: number;
  OBEGPID: number;
  Begehungsart: string;
  letzte: string /* DateTime */;
  Wochentag: string;
  Termin: string /* DateTime */;
  abgeschlossen: boolean;
  Intervallbeginn: string /* DateTime */;
  Intervall: number;
  _tag: number;
  Beschreibung: string;
  Gruppen: string;
  [key: string]: unknown;
}

export interface BegehungHistorieNode extends DBStatus {
  ID: number;
  Begehungsart: string;
  BegehDatum: string /* DateTime */;
  Abgeschlossen: boolean;
  Bemerkung: string;
}

export interface BegehungResult {
  obege?: Table<BegehungPlanNode>;
  sxbeg?: SXBEG[];
  obegp_history: Table<BegehungHistorieNode>;
}
